// Auto-generated - do not edit manually
import React from "react";
import { FlagIcon } from "../FlagIcon";
import type { FlagIconProps } from "../types";

const svgContent = `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="flag-icon_bj"><g id="flag"><mask id="mask0_1161_20330" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="3" width="16" height="12"><rect id="mask" x="1" y="3" width="16" height="12" fill="white"/></mask><g mask="url(#mask0_1161_20330)"><g id="contents"><path id="middle" fill-rule="evenodd" clip-rule="evenodd" d="M1 3H17V15H1V3Z" fill="#DD2C2B"/><path id="top" fill-rule="evenodd" clip-rule="evenodd" d="M1 3V10H17V3H1Z" fill="#FECA00"/><rect id="Rectangle 11" x="1" y="3" width="7" height="12" fill="#5EAA22"/></g></g></g></g></svg>`;

export const FlagBJ: React.FC<FlagIconProps> = (props) => (
  <FlagIcon {...props} svgContent={svgContent} />
);
